import type { ComponentProps } from "react";
import { MediaImage } from "./media-image";
import { ModuleIcon } from "./module-icon";
import { resolveModuleLucideIcon } from "components/ui/v2/sidebar/module-lucide-registry";
import { normalizeSvgSrc } from "utils/normalize-svg-src";

type SvgSrcProp = ComponentProps<typeof MediaImage>["src"];

interface SvgV2Props extends ComponentProps<typeof MediaImage> {
  readonly src: SvgSrcProp;
  readonly moduleOpacity?: boolean;
}

/**
 * @deprecated Use ModuleIcon for module icons or MediaImage for illustrations.
 * Kept for backward compatibility during Lucide migration.
 */
export default function SvgV2({
  src,
  moduleOpacity = true,
  width,
  height,
  className,
  onClick,
  alt,
}: SvgV2Props) {
  const resolvedSrc = normalizeSvgSrc(src);
  const moduleIcon = resolveModuleLucideIcon(resolvedSrc);

  if (moduleIcon) {
    const resolvedWidth = width ?? 20;
    return (
      <ModuleIcon
        path={resolvedSrc}
        size={resolvedWidth}
        className={className}
        muted={moduleOpacity}
        onClick={onClick}
        aria-label={alt}
      />
    );
  }

  return (
    <MediaImage
      src={src}
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      alt={alt}
    />
  );
}
